import { Action, ActionCreator, Reducer } from "redux";
import { UserContractorContext } from "../../pages/settings/users/models/UserContractorContext";

export interface UserContextState {
	userContext: UserContractorContext
}

export enum UserContextActionType {
  get = "RECEIVE_CONTEXT",
}


interface UserContextAction {
  type: UserContextActionType;
  context: UserContractorContext;
  [key: string]: unknown;
}

export const getUserContext: ActionCreator<UserContextAction> = (context: UserContractorContext) =>
	({ type: UserContextActionType.get, context });


type KnownAction = UserContextAction;

export const reducer: Reducer<UserContextState> = (
  state: UserContextState | undefined,
  incomingAction: Action
): UserContextState => {
	if (!state) {
		return {
			userContext: {Id: 0, Login: ``, Title: ``, Email: ``, Inn: ``, Kpp: ``, SapCodes: [], Contractors: [], OwnerId: null}
		}
	}
	const action = incomingAction as KnownAction;

	switch (action.type) {
		case `RECEIVE_CONTEXT`:
			state = {
				userContext: action.context
			}
	}
	
	return state;
};